// extracted by mini-css-extract-plugin
export var dropdownButton = "_3h-0";
export var fullWidthDropdownButton = "_3h-1";
export var icon = "_3h-3";
export var iconPlaceholder = "_3h-2";
export var menuItemRow = "_3h-5";
export var shortcutContainer = "_3h-4";